export default {
  SERVER_ENDPOINT: import.meta.env.VITE_SERVER_ENDPOINT,
  WS_SERVER_ENDPOINT: import.meta.env.VITE_WS_SERRVER_ENDPOINT,
  MAPBOXGL_ACCESS_TOKEN: import.meta.env.VITE_MAPBOX_TOKEN,
};
